const OPEN = '\u27e6'
const CLOSE = '\u27e7'
const PAD = '\u00b7'

// ~25% length growth is inside the 20-30% band Hungarian needs.
const padFor = (text) => PAD.repeat(Math.max(1, Math.ceil(text.length * 0.25)))

const pseudoizeValue = (value) => {
  if (typeof value === 'string') return `${OPEN}${value}${padFor(value)}${CLOSE}`

  if (Array.isArray(value)) return value.map(pseudoizeValue)

  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = pseudoizeValue(value[key])
      return acc
    }, {})
  }

  return value
}

export const pseudoizeResources = (resources) => pseudoizeValue(resources)
